import React from "react";
import { SizeValue, Text } from "@fluentui/react-northstar";
import { TeamsTextWeight } from "shared/types/TeamsTextWeight";

interface TableHeaderProps {
    text: string;
    size: SizeValue;
    weight: TeamsTextWeight;
}

const TableHeader: React.FC<TableHeaderProps> = (props: TableHeaderProps) => {
    return (
        <Text size={props.size} weight={props.weight}>
            {props.text}
        </Text>
    );
};

export default TableHeader;
